// extracted by mini-css-extract-plugin
export default {"container":"Qr_container__wOlYp","header":"Qr_header__a-lEA","collage":"Qr_collage__a7RvI","collageBody":"Qr_collageBody__Bsj29"};